import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import PlayersView from 'views/players'; // Importing PlayersView component
import Filter from 'views/reports/coupons_report/filter'; // Importing Filter component for reports
import Table from 'views/reports/coupons_report/table'; // Importing Table component for reports
import Record from 'views/reports/coupons_report/record'; // Importing Record component for reports
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the deposit report view.
 * @extends JetView
 */
export default class depositReportView extends JetView {
    /**
     * Configures the layout of the deposit report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const vthis = this; // Reference to the current instance

        // Right section layout containing PlayersView and Record
        const right = {
            type: 'wide',
            rows: [PlayersView, Record],
        };

        // Alternative right section layout for smaller screens
        const right2 = {
            height: 1,
            id: 'right2',
            width: screen.width - 54,
            type: 'wide',
            rows: [Record],
        };

        // Toolbar configuration with pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select',
                    options: ['10', '20', '50', '100'], // Options for number of items per page
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on selection change
                            $$('datatable4').getPager().config.size = this.getValue() * 1;
                            $$('datatable4').refresh();
                            $$('datatable4').scrollTo(100, 0);
                        },
                    },
                },
                {
                    view: 'pager',
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    animate: {
                        subtype: 'out',
                    },
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export selection
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            var table = $$('datatable4');
                            var size = $$('datatable4').getPager().config.size;
                            var page = $$('datatable4').getPage();
                            var first = size * page;
                            var last = first + size - 1;
                            if (value !== '') {
                                vthis.app.callEvent('export:filter', [{ value: value, first: first, last: last }]);
                            }
                        },
                    },
                },
            ],
        };

        // Second toolbar configuration for export options
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {},
                {
                    view: 'richselect',
                    name: 'Export',
                    id: 'Export2',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export selection
                    options: [
                        { id: '1', value: 'Excel' }, // Export to Excel option
                        { id: '2', value: 'PDF' }, // Export to PDF option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            if (value == 1) {
                                var table = $$('datatable2');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Cupones',
                                    ignore: { detailTittle: true },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    webix.toPDF($$('datatable2'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable2').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Cupones',
                                        autowidth: true,
                                        ignore: { detailTittle: true },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export2').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        // Left section layout containing toolbars, filter, and table
        const left = {
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply current theme to toolbar
                    elements: [
                        {
                            id: 'test',
                            view: 'label',
                            label: _('Reporte de Cupones'), // Label for the report
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // First toolbar
                toolbar2, // Second toolbar
            ],
        };

        // Advanced details section with accordion layout
        const avanc = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [
                { id: 'dColl', header: _('Detalles Avanzados'), body: right }, // Advanced details header and body
            ],
        };

        // Responsive advanced details section
        const avancResp = {
            view: 'accordion',
            multi: true,
            collapsed: true,
            id: 'carousel1',
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 250,
                    on: {
                        onItemClick: function () {
                            // Adjust scrolling behavior on item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Main layout configuration for the view
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer between sections
                        screen.width < 500 || screen.height < 500
                            ? right2 // Use right2 layout for small screens
                            : avanc, // Use advanced layout for larger screens
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the deposit report view.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Adjust layout for small screens
            if (screen.width < 500 || screen.height < 500) {
                $$('res').hide(); // Hide resizer
                var childs = $$('toolbar').getChildViews();
                $$('toolbar').removeView(childs[2]); // Remove export option from toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
            // jQuery function to calculate scroll bottom
            $.fn.scrollBottom = function () {
                return $(document).height() - this.scrollTop() - this.height();
            };
            // Hide search button for larger screens
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide();
            }
        });
    }
}

// FILE DOCUMENTED
